export const projectTagToFullName = {
  'HS': 'HomeScapes',
  'GS': 'GardenScapes',
  'WS': 'WildScapes',
  'TS': 'Township',
  'FD': 'Fishdom',
  'FS': 'Farmscapes',
  'FDS': 'Fishdom solitaire',
  'PB': 'Puzzle breaker',
  'FDB': 'Fishdom Blast',
}

export default {
  filters: {
    humanizeProjectTag (value) {
      return projectTagToFullName.hasOwnProperty(value.toUpperCase())
        ? projectTagToFullName[value.toUpperCase()]
        : null
    }
  }
}